import { useMemo, useState } from 'react';

export const useDirtyForm = <T,>(initialValue: T, serialize: (value: T) => string) => {
  const [baselineSnapshot, setBaselineSnapshot] = useState(() => serialize(initialValue));

  const isDirty = useMemo(() => {
    return (value: T) => serialize(value) !== baselineSnapshot;
  }, [baselineSnapshot, serialize]);

  const markClean = (value: T) => {
    setBaselineSnapshot(serialize(value));
  };

  return {
    isDirty,
    markClean,
  };
};
